const links = document.links; 
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
  } 
}

window.onload = function() {
  const floatingButton = document.getElementById('floatingButton');
  const closeBtn = document.getElementById('closeBtn');
  const closeBtnWrapper = document.createElement('div'); // Create a wrapper

  if (floatingButton && closeBtn) {
    const hideButton = function() {
      floatingButton.style.display = 'none';
    };

    // Wrap the close button with a larger area for tapping
    closeBtnWrapper.appendChild(closeBtn);
    floatingButton.appendChild(closeBtnWrapper);  // Add wrapper to button container

    closeBtnWrapper.addEventListener('touchstart', hideButton); // Use wrapper for touch event
    closeBtn.addEventListener('click', hideButton); // Keep click event for desktop
  } else {
    console.error('Elements not found');
  }
};